import React, { Component } from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { Table, Icon } from "antd";
import { RejectedBPType } from "../types";
import { PaginationInfoType } from "../../BusinessPartnerLists/types";
import "../index.scss";
import ChangeLogModal from "../../ChangeLog/components/changeLogModal";
import { ViewportType } from "../../App/types";
import {
  BusinessPartnerType,
  PseudoroleValueCodeMapType,
} from "../../BusinessPartnerDetails/types";

interface IProps extends RouteComponentProps<any> {
  statuses: [];
  rejectedBPs: RejectedBPType[] | null;
  pageInfo: PaginationInfoType;
  viewport: ViewportType;
  setMenuKey: (key: string) => any;
  fetchRejectedBP: (payload: any) => any;
  fetchLookUp: () => any;
  rejectedBPlist: BusinessPartnerType[] | null;
  pseudoroleValueCodeMap: PseudoroleValueCodeMapType | null;
}
interface SortInfoType {
  columnKey: string;
  field: string;
  order: string;
}

const capitalize = (content) =>
  content.charAt(0).toUpperCase() + content.slice(1);

interface IStates {
  pageInfo: PaginationInfoType;
  changeLogVisibility: boolean;
  sortInfo: null | SortInfoType;
  changeLogData: BusinessPartnerType;
}

const initialState = {};

class RejectedBusinessPartnersComponent extends Component<IProps, IStates> {
  constructor(props) {
    super(props);

    this.state = {
      pageInfo: null,
      sortInfo: null,
      changeLogVisibility: false,
      changeLogData: null,
    };
  }

  componentDidMount() {
    const menuKey = this.props.location.pathname
      .replace(/\//gi, "")
      .replace(/-/gi, " ");
    this.props.setMenuKey(menuKey);

    const rejectedBpListPayload = {
      sortBy: "",
      isSortAscending: true,
      page: 1,
      pageSize: 15,
      genericSearch: "",
      searchData: [],
    };

    this.props.fetchLookUp();

    this.props.fetchRejectedBP(rejectedBpListPayload);
  }

  changeLogToggle = (businessPartner: BusinessPartnerType | null) => {
    if (!this.state.changeLogVisibility) {
      this.setState({
        changeLogVisibility: !this.state.changeLogVisibility,
        changeLogData: businessPartner,
      });
    } else {
      this.setState({
        changeLogVisibility: !this.state.changeLogVisibility,
        changeLogData: null,
      });
    }
  };

  onChange = (pagination, filters, sorter) => {
    const searchPayload = {
      sortBy:
        sorter && Object.keys(sorter).length > 0
          ? capitalize(sorter.columnKey)
          : "",
      isSortAscending:
        sorter && Object.keys(sorter).length > 0
          ? sorter.order == "ascend"
          : false,
      page: pagination.current,
      pageSize: pagination.pageSize,
      genericSearch: "",
      searchData: Object.keys(filters)
        .filter((columnKey) => filters[columnKey].length > 0)
        .map((columnKey) => ({
          datatype: "number",
          value: filters[columnKey][0].toString(),
          dbKey: capitalize(columnKey),
        })),
    };
    this.setState({ sortInfo: sorter });
    this.props.fetchRejectedBP(searchPayload);
  };

  render() {
    const { pageInfo } = this.props;

    const columns = [
      {
        title: "BP ID",
        dataIndex: "bpId",
        key: "bpId",
        width: 70,
      },
      {
        title: "BP Name One",
        dataIndex: "bpName",
        key: "bpName",
        sorter: true,
        width: 250,
      },
      {
        title: "Role",
        dataIndex: "pbConstantRef",
        key: "pbConstantRef",
        sorter: false,
        width: 250,
        render: (text: any, record: BusinessPartnerType) => {
          return (
            <div>
              {(record.pseudoRoleBpmap.length &&
                this.props.pseudoroleValueCodeMap &&
                this.props.pseudoroleValueCodeMap.get(
                  record.pseudoRoleBpmap[0].pbConstantRef
                )) ||
                ""}
            </div>
          );
        },
        filters:
          this.props.pseudoroleValueCodeMap &&
          Array.from(this.props.pseudoroleValueCodeMap).map((value, key) => {
            return {
              text: value[1],
              value: value[0],
            };
          }),
        filterMultiple: false,
      },
      {
        title: "City",
        dataIndex: "bpCityRefName",
        key: "bpCityRefName",
        width: 150,
      },
      {
        title: "Street 1",
        dataIndex: "bpStreet",
        key: "bpStreet",
      },
      {
        title: "ZIP / Postal",
        dataIndex: "bpPostalcodeRefName",
        key: "bpPostalcodeRefName",
        width: 150,
      },
      {
        title: "VIES Number",
        dataIndex: "taxNumber",
        key: "taxNumber",
        width: 150,
        render: (tax: any) => (tax.length > 0 ? tax[0].tnVIESNumber : ""),
      },
      {
        title: "Action",
        width: 80,
        render: (text: string, record: BusinessPartnerType) => {
          return (
            <div className="table-action">
              <Link
                to={`/business-partner-details/${record.bpId}`}
                title="Edit"
              >
                <Icon type="edit" style={{ fontSize: "20px" }} />
              </Link>
              {record && record.changeLog.length > 0 && (
                <Icon
                  type="diff"
                  onClick={() => this.changeLogToggle(record)}
                  title="Change Log"
                  style={{ fontSize: "20px", marginLeft: "10px" }}
                />
              )}
            </div>
          );
        },
      },
    ];
    return (
      <div className="wrapper">
        <h2 className="page-title">
          Rejected Business Partner
          <span> List</span>
        </h2>

        <Table
          size="small"
          rowKey="bpId"
          columns={columns}
          dataSource={this.props.rejectedBPlist || []}
          onChange={this.onChange}
          className="rejected-bp-table"
          pagination={{
            current: pageInfo.currentPage,
            total: pageInfo.totalRecords,
            pageSize: pageInfo.pageSize,
            showSizeChanger: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} Business Partners`,
            pageSizeOptions: ["15", "30", "50", "100"],
          }}
        />
        {this.state.changeLogVisibility && (
          <ChangeLogModal
            close={this.changeLogToggle}
            changeLogList={this.state.changeLogData}
          />
        )}
      </div>
    );
  }
}

export default RejectedBusinessPartnersComponent;
